import { MutableRefObject, useCallback, useEffect, useRef, useState } from "react";
import { useDraggable } from "react-use-draggable-scroll";

export const useDraggableScroll = () => {
  const [canScroll, setCanScroll] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const { events } = useDraggable(ref as MutableRefObject<HTMLElement>);

  const handleKeyEvent = useCallback((event: KeyboardEvent, state: boolean) => {
    const editableElement =
      event.target instanceof HTMLElement && event.target.closest("input, textarea, select, [contenteditable='true']");

    if (event.code === "Space" && !editableElement) {
      globalThis.getSelection()?.removeAllRanges();
      event.preventDefault();
      setCanScroll(state);
    }
  }, []);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      handleKeyEvent(event, true);
    },
    [handleKeyEvent],
  );

  const handleKeyUp = useCallback(
    (event: KeyboardEvent) => {
      handleKeyEvent(event, false);
    },
    [handleKeyEvent],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, [handleKeyDown, handleKeyUp]);

  return { ref, events, canScroll };
};
